// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { IconWrapper } from "@insite/mobius/Icon";
import { MediaQuery } from "@rugby/XDL/Utilities/MediaQuery";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    cssOverrides: {
        scrim: css`
            @media print {
                display: none;
            }
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 15px;
            margin: 0 auto;
            width: 100%;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {
    css: css`
        max-width: none;
        flex-basis: auto;
        ${MediaQuery.lte("md")} {
            flex-basis: 100%;
        }
    `,
};

cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    css: css`
        max-width: none;
        flex-basis: auto;
        &&& {
            margin-left: auto;
        }
    `,
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    css: css`
        width: auto;
    `,
};

cookiePrivacyPolicyPopupStyles.closeGridItem = {
    css: css`
        max-width: none;
        flex-basis: auto;
    `,
};

cookiePrivacyPolicyPopupStyles.closeButton = {
    variant: "secondary",
    css: css`
        width: auto;
        padding: 0 20px;
        align-items: center;
        display: flex;
        ${IconWrapper} {
            top: initial;
        }
    `,
};
